import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { CarouselMutationKeys } from '../../../keys'
import {
	UpdateCarouselItemsRequest,
	UpdateCarouselItemsResponse,
} from '../../../type'
import { updateCarouselItems } from '../../services'

interface UseMutationUpdateCarouselItemProps {
	id: string
	payload: UpdateCarouselItemsRequest
}

export default function useMutationUpdateCarouselItem(
	props?: UseBaseMutationOptions<
		UpdateCarouselItemsResponse,
		UseMutationUpdateCarouselItemProps
	>,
) {
	return useMutation({
		mutationKey: [CarouselMutationKeys.UpdateCarouselItem],
		mutationFn: (params) => updateCarouselItems(params.id, params.payload),
		...props,
	})
}
